import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signOut } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator, doc, updateDoc, getDoc, collection, setDoc, getDocs, query, where, deleteField, serverTimestamp, deleteDoc, addDoc, orderBy } from 'firebase/firestore';
import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { addDays, format, isSameDay, parseISO } from "date-fns";
import { getFunctions, connectFunctionsEmulator, httpsCallable } from 'firebase/functions';
import { toMillis } from './utils/ratingWindow';

const firebaseConfig = {
    apiKey: "AIzaSyA0D0bdyi0mLXh2caELffJghKatcpoAjsg",
    authDomain: "sdcl-knocap-fb.firebaseapp.com",
    projectId: "sdcl-knocap-fb",
    storageBucket: "sdcl-knocap-fb.firebasestorage.app",
    messagingSenderId: "571887393269",
    appId: "1:571887393269:web:37bbe128d8c0c3d387e8bc",
    measurementId: "G-GJWX0N3NC8"
};


const app = initializeApp(firebaseConfig);
const storage = getStorage(app);
const db = getFirestore(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();
provider.addScope('https://www.googleapis.com/auth/drive.file');
provider.addScope('https://www.googleapis.com/auth/userinfo.profile');
provider.addScope('https://www.googleapis.com/auth/userinfo.email');

const functions = getFunctions(app, 'us-central1');
// Connect to emulators when REACT_APP_USE_EMULATOR=true is set in .env.local
// To enable locally, create .env.local file with: REACT_APP_USE_EMULATOR=true
if (process.env.REACT_APP_USE_EMULATOR === 'true') {
    connectFunctionsEmulator(functions, "127.0.0.1", 5002);
    connectFirestoreEmulator(db, "127.0.0.1", 8080);
    console.log("USE_EMULATOR:", process.env.REACT_APP_USE_EMULATOR);

}


// ------------------- TUO -------------------

export async function getUserProfile(email) {
    try {
        const docRef = doc(db, "Users", email);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            return docSnap.data();
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error getting user profile:", error);
        throw error;
    }
}

export async function updateUserBio(email, bio) {
    try {
        const docRef = doc(db, "Users", email);
        await updateDoc(docRef, {
            bio: bio
        });
        return true;
    } catch (error) {
        console.error("Error updating user bio:", error);
        throw error;
    }
}

export async function updateUserProfile(email, profileData) {
    try {
        const docRef = doc(db, "Users", email);
        const updateData = {};

        if (profileData.bio !== undefined) updateData.bio = profileData.bio;
        if (profileData.phone !== undefined) updateData.phone = profileData.phone;
        if (profileData.discord !== undefined) updateData.discord = profileData.discord;
        if (profileData.github !== undefined) updateData.github = profileData.github;
        if (profileData.slack !== undefined) updateData.slack = profileData.slack;
        if (profileData.whatsapp !== undefined) updateData.whatsapp = profileData.whatsapp;
        if (profileData.linkedin !== undefined) updateData.linkedin = profileData.linkedin;
        if (profileData.strengths !== undefined) updateData.strengths = profileData.strengths;

        await updateDoc(docRef, updateData);
        return true;
    } catch (error) {
        console.error("Error updating user profile:", error);
        throw error;
    }
}

export async function getUserName(email) {
    const docRef = doc(db, "Users", email);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return docSnap.data()["name"];
    } else {
        return email;
    }
}

export async function getCourseId(teamId) {
    const docRef = doc(db, "Groups", teamId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return docSnap.data()["courseId"];
    } else {
        return null;
    }
}

export async function getEventByID(eventId) {
    const db = getFirestore(app);
    const docRef = doc(db, "Events", eventId);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
        return docSnap.data();
    } else {
        return null;
    }
}

export const logoutUser = () => {
    const auth = getAuth();

    signOut(auth)
        .then(() => {
            console.log("User signed out");
        })
        .catch((error) => {
            console.error("Error signing out: ", error);
        });
};

export async function getAllEventIds(groupId) {
    try {
        const eventIdsRef = collection(db, "Groups", groupId, "eventIds");
        const eventIdsSnapshot = await getDocs(eventIdsRef);
        const eventIds = {};
        eventIdsSnapshot.forEach((doc) => {
            eventIds[doc.id] = true;
        });
        return eventIds;
    } catch (error) {
        console.error("Error getting event IDs:", error);
        return {};
    }
}

export async function getAllEventData(groupId) {
    try {
        const eventsQuery = query(
            collection(db, "Events"),
            where("groupId", "==", groupId)
        );
        const snapshot = await getDocs(eventsQuery);

        return snapshot.docs
            .map(d => ({ id: d.id, ...d.data() }))
            .sort((a, b) => (a.created_at || 0) - (b.created_at || 0));
    } catch (error) {
        console.error("Error getting all event data:", error);
        return [];
    }
}

export async function eventCountLastTwoDay(groupId) {
    const now = new Date();
    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(now.getDate() - 2);
    const formattedTwoDaysAgo = twoDaysAgo.toISOString().split("T")[0];


    const eventsRef = collection(db, "Events");
    const eventsQuery = query(
        eventsRef,
        where("groupId", "==", groupId),
        where("date", ">=", formattedTwoDaysAgo)
    );

    const snapshot = await getDocs(eventsQuery);
    return snapshot.size;
}



// ------------------- Jeff -------------------
export async function getTeamName(user, teamId) {
    const docRef = doc(db, "Groups", teamId);
    const docSnap = await getDoc(docRef);
    let teamName = null;
    if (docSnap.exists()) {
        teamName = docSnap.data()["groupName"];
    } else {
        console.log("No such document!");
    }
    return teamName;
}

export async function getTeamMembers(user, groupId) {
    let team = [];
    try {
        const docRef = doc(db, "Groups", groupId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            team = docSnap.data().members || [];
        }
    } catch (error) {
        console.error("Error fetching team members:", error);
    }
    return { members: team };
}


export async function getTeamDailySessions(user, date, teamId) {
    try {
        const dateString = format(date, 'yyyy-MM-dd');
        const eventsQuery = query(
            collection(db, "Events"),
            where("groupId", "==", teamId),
            where("date", "==", dateString)
        );
        const snapshot = await getDocs(eventsQuery);

        return snapshot.docs
            .map(d => d.data())
            .sort((a, b) => (a.created_at || 0) - (b.created_at || 0));
    } catch (error) {
        console.error("Error fetching team daily sessions:", error);
        throw error;
    }
}

export async function getTeamWeeklySessions(weekStartDate, teamId) {
    try {
        const startStr = format(weekStartDate, 'yyyy-MM-dd');
        const endStr = format(addDays(weekStartDate, 6), 'yyyy-MM-dd');

        const eventsQuery = query(
            collection(db, "Events"),
            where("groupId", "==", teamId),
            where("date", ">=", startStr),
            where("date", "<=", endStr)
        );
        const snapshot = await getDocs(eventsQuery);

        return snapshot.docs
            .map(d => d.data())
            .sort((a, b) => (a.created_at || 0) - (b.created_at || 0));
    } catch (error) {
        console.error("Error fetching team weekly sessions:", error);
        throw error;
    }
}

export async function uploadFile(file, teamId, eventId) {
    const colRef = collection(db, "Files");
    const newDocRef = doc(colRef);
    const newDocId = newDocRef.id;

    const courseId = await getCourseId(teamId);
    const fileRef = ref(storage, `${courseId}/${teamId}/${newDocId}/${file.name}`);
    await uploadBytes(fileRef, file);
    const downloadURL = await getDownloadURL(fileRef);
    const fileMeta = {
        name: file.name,
        eventId,
        url: downloadURL,
        fileId: newDocId,
    };

    if (file.type) fileMeta.type = file.type;
    if (file.size) fileMeta.size = file.size;
    await setDoc(newDocRef, fileMeta);
    const { eventId: _, ...returnData } = fileMeta;
    return returnData;
}

export async function updateFileEventId(fileId, eventId) {
    try {
        const fileRef = doc(db, "Files", fileId);
        await updateDoc(fileRef, { eventId });
        console.log(`Updated eventId for file ${fileId} → ${eventId}`);
    } catch (error) {
        console.error(`Failed to update eventId for file ${fileId}:`, error);
    }
}


export async function writeNewSession(session, user, files = [], teamId) {
    try {
        //console.log(session);
        session.groupId = teamId;

        const colRef = collection(db, "Events");
        const newDocRef = doc(colRef);
        const newDocId = newDocRef.id;

        session.eventId = newDocId;

        const filePromises = files.map(file => uploadFile(file, teamId, newDocId));
        const files2 = await Promise.all(filePromises);

        session.files = files2;
        session.contributorIds = session.contributors.map(contributor => contributor.email);
        session.courseId = await getCourseId(teamId);
        if (!session.reviewDeadline) {
            let deadlineDays = 7;
            let deadlineEnabled = true;
            if (session.courseId) {
                const courseSnap = await getDoc(doc(db, "Courses", session.courseId));
                if (courseSnap.exists()) {
                    const courseSettings = courseSnap.data()?.settings ?? {};
                    deadlineDays = courseSettings.deadlineDays ?? 7;
                    deadlineEnabled = courseSettings.deadlineEnabled ?? true;
                }
            }
            if (deadlineEnabled) {
                const defaultDeadline = new Date(Date.now() + deadlineDays * 24 * 60 * 60 * 1000);
                session.reviewDeadline = defaultDeadline.toISOString();
                session.reviewDeadlineDays = deadlineDays;
            }
        }
        await setDoc(newDocRef, session);

        const updateDocRef = doc(db, "Groups", teamId, "eventIds", newDocId);
        // await updateDoc(updateDocRef, {
        //     eventIds: arrayUnion(newDocId)
        // });
        await setDoc(updateDocRef, {});

        const new_data = await getEventByID(newDocId);
        return new_data;

        // const docRef = await addDoc(colRef, session);

    } catch (error) {
        console.error("Error writing new session:", error);
        throw error;
    }
}

function artifactsChanged(oldEvent, updatedFields, mergedFiles) {
    const oldFileIds = (oldEvent.files || []).map(f => f.fileId).sort();
    const newFileIds = (mergedFiles || []).map(f => f.fileId).sort();
    if (JSON.stringify(oldFileIds) !== JSON.stringify(newFileIds)) return true;

    const oldDocLinks = (oldEvent.googleDocs || []).map(d => d.link).filter(Boolean).sort();
    const newDocLinks = (updatedFields.googleDocs || []).map(d => d.link).filter(Boolean).sort();
    if (JSON.stringify(oldDocLinks) !== JSON.stringify(newDocLinks)) return true;

    const oldFigmaLinks = (oldEvent.figmaFiles || []).map(f => f.link).filter(Boolean).sort();
    const newFigmaLinks = (updatedFields.figmaFiles || []).map(f => f.link).filter(Boolean).sort();
    if (JSON.stringify(oldFigmaLinks) !== JSON.stringify(newFigmaLinks)) return true;

    if ((oldEvent.prLink || '') !== (updatedFields.prLink || '')) return true;

    return false;
}

export async function updateSession(eventId, updatedFields, user, newFiles = []) {
    try {
        const docRef = doc(db, "Events", eventId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const event = docSnap.data();

            const existingFiles = event.files || [];
            const existingFileIds = existingFiles.map(file => file.fileId);
            const keepIds = newFiles.map(file => file.fileId);
            const newFiles1 = newFiles.filter(file => !existingFileIds.includes(file.fileId));

            const filePromises = newFiles1.map(file => uploadFile(file, event.groupId, eventId));
            const newFiles2 = await Promise.all(filePromises);

            // const newFileObjects = newFileURLs.map((url, index) => ({
            //     name: newFiles[index].name,
            //     url: url
            // }));

            // const mergedFiles = [...existingFiles];
            const updatedFiles = existingFiles.filter(file => keepIds.includes(file.fileId));
            const mergedFiles = [...updatedFiles, ...newFiles2];


            const temp = {
                ...event,
                ...updatedFields,
                files: mergedFiles,
            };
            temp.contributorIds = temp.contributors.map(contributor => contributor.email);

            if (artifactsChanged(event, updatedFields, mergedFiles)) {
                temp.artifactLastModifiedAt = serverTimestamp();
                // Only reset deadline if one was previously set (i.e. deadline feature is enabled for this activity)
                if (temp.reviewDeadline) {
                    const deadlineDays = temp.reviewDeadlineDays || 7;
                    const newDeadline = new Date();
                    newDeadline.setDate(newDeadline.getDate() + deadlineDays);
                    temp.reviewDeadline = newDeadline.toISOString();
                }
            }

            await setDoc(docRef, temp);

            const new_data = await getEventByID(eventId);
            return new_data;

        } else {
            throw new Error("User document not found");
        }
    } catch (error) {
        console.error("Error updating session:", error);
        // Detect Firestore permission issue
        if (error.code === "permission-denied") {
            return {
                ok: false,
                code: "PERMISSION_DENIED",
                message: "You don’t have permission to update this session. Only contributors listed on the card can edit.",
            };
        }

        // Fallback for all other errors
        return {
            ok: false,
            code: "UNKNOWN_ERROR",
            message: error.message || "An unexpected error occurred while updating the session.",
        };
    }
}

export async function getTeamAllSessions(teamId) {
    try {
        const eventsQuery = query(
            collection(db, "Events"),
            where("groupId", "==", teamId)
        );
        const eventsSnapshot = await getDocs(eventsQuery);
        const events = eventsSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

        if (events.length === 0) return [];

        // Batch-fetch all Assessments for these events. Firestore "in" supports up to 30 values.
        // Assessments are written keyed by the event's `eventId` field (see submitAssessment),
        // which is not always equal to the Firestore doc id for imported/legacy events — so we
        // join on the `eventId` field and fall back to the doc id.
        const eventIds = events.map(e => e.eventId || e.id);
        const assessmentsByEventId = new Map();
        for (let i = 0; i < eventIds.length; i += 30) {
            const batchIds = eventIds.slice(i, i + 30);
            const assessmentsQuery = query(
                collection(db, "Assessments"),
                where("eventId", "in", batchIds)
            );
            const batchSnapshot = await getDocs(assessmentsQuery);
            batchSnapshot.docs.forEach(d => {
                const data = d.data();
                const list = assessmentsByEventId.get(data.eventId) || [];
                list.push(data);
                assessmentsByEventId.set(data.eventId, list);
            });
        }

        const enriched = events.map(eventData => {
            const assessments = assessmentsByEventId.get(eventData.eventId || eventData.id) || [];
            const artifactLastModified = eventData.artifactLastModifiedAt;
            let actualSubmitted;
            if (artifactLastModified) {
                const modifiedMs = artifactLastModified.toMillis();
                actualSubmitted = assessments.filter(data => {
                    const ratedMs = Math.max(
                        data.submittedAt?.toMillis() || 0,
                        data.updatedAt?.toMillis() || 0
                    );
                    return ratedMs >= modifiedMs;
                }).length;
            } else {
                actualSubmitted = assessments.length;
            }

            const { id, ...rest } = eventData;
            return {
                ...rest,
                totalSubmitted: actualSubmitted
            };
        });

        return enriched.sort((a, b) => (a.created_at || 0) - (b.created_at || 0));
    } catch (error) {
        console.error("Error fetching team all sessions:", error);
        throw error;
    }
}

// GitHub Integration Functions
export async function updateAllReposToGroup(groupId, installationId, repos) {
    if (!groupId || !installationId || !Array.isArray(repos)) {
        throw new Error("Missing groupId, installationId or invalid repos array");
    }

    const groupRef = doc(db, "Groups", groupId);
    const groupSnap = await getDoc(groupRef);

    if (!groupSnap.exists()) {
        throw new Error("Group not found");
    }

    const currentRepos = groupSnap.data()?.github?.all_repos || {};
    const activeRepo = groupSnap.data()?.github?.active_repo || null;
    const now = serverTimestamp();

    // Set of repo IDs from GitHub API under this installation
    const newRepoIds = new Set(repos.map((r) => r.id.toString()));

    const updates = {};

    // Add or update repos from GitHub
    repos.forEach(repo => {
        const key = `github.all_repos.${repo.id}`;
        updates[key] = {
            installation_id: installationId,
            repo: repo,
            last_fetched: now,
        };
    });

    // Only delete repos that match the same installation_id and are missing from the new list
    for (const [repoId, value] of Object.entries(currentRepos)) {
        if (
            value.installation_id === installationId &&
            !newRepoIds.has(repoId)
        ) {
            updates[`github.all_repos.${repoId}`] = deleteField();
        }
    }
    if (
        activeRepo?.repo?.id &&
        !newRepoIds.has(activeRepo.repo.id.toString())
    ) {
        updates["github.active_repo"] = null;
    }

    updates["github.repos_fetched_at"] = now;

    await updateDoc(groupRef, updates);
    return { saved: true, count: repos.length, cleaned: true };
};

// old name: getTeamGitHubInfo
export async function getTeamActiveRepo(groupId) {
    try {
        if (!groupId) {
            console.warn("Missing user or groupId in getTeamActiveRepo.");
            return null;
        }

        const docRef = doc(db, "Groups", groupId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            console.log("Group document does not exist.");
            return null;
        }

        const data = docSnap.data();
        const github = data?.github;

        if (!github || typeof github !== "object") {
            console.log("No valid GitHub field found.");
            return null;
        }

        const activeRepo = github.active_repo;

        // Optionally log what you're returning
        if (!activeRepo) {
            console.log("No active repo set.");
        }

        return activeRepo || null;

    } catch (error) {
        console.error("Error fetching GitHub info for group:", error);
        return null;
    }
}

export async function getTeamAllRepo(groupId) {
    try {
        const docRef = doc(db, "Groups", groupId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            const data = docSnap.data();
            const github = data.github || null;

            if (!github) {
                console.log("No GitHub info found.");
                return null
            }
            const allRepo = github.all_repos || {};

            return allRepo || {}; //return null if no have active repo
        } else {
            console.log("Group document does not exist.");
            return null;
        }
    } catch (error) {
        console.error("Error fetching GitHub info for group:", error);
        throw error;
    }
}

// use boolean to present the remove status
export const removeRepoFromGroup = async (groupId, repoId) => {
    const docRef = doc(db, "Groups", groupId);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
        console.log("Group not found.")
        return false
    }
    const data = docSnap.data();
    const activeRepo = data.github?.active_repo || null;
    const updates = {};
    updates[`github.all_repos.${repoId}`] = deleteField();

    if (activeRepo?.repo?.id === repoId) {
        updates["github.active_repo"] = null;
    }
    await updateDoc(docRef, updates);
    return true
};

export const switchActiveRepo = async (groupId, repoId) => {
    const docRef = doc(db, "Groups", groupId);
    const docSnap = await getDoc(docRef);
    if (!docSnap.exists()) {
        console.log("Group not found.")
        return false
    }

    const data = docSnap.data();
    const allRepos = data.github?.all_repos || {};
    const newActive = allRepos[repoId];

    if (!newActive) {
        console.log("Repo not found in all_repos for repoId: ", repoId)
        return false
    }

    const now = serverTimestamp();

    await updateDoc(docRef, {
        "github.active_repo": {
            ...newActive,
            active_date: now
        }
    });
    return true;
};

export async function removeActiveRepo(groupId) {
    if (!groupId) {
        throw new Error("Missing groupId");
    }

    const groupRef = doc(db, "Groups", groupId);

    try {
        await updateDoc(groupRef, {
            "github.active_repo": null,
        });
        return true;
    } catch (error) {
        console.error("Failed to remove active repo:", error);
        return false;
    }
}


export async function updateGitHubUsername(groupId, email, githubUsername) {
    try {
        const docRef = doc(db, "Groups", groupId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            throw new Error("Group not found");
        }

        const groupData = docSnap.data();

        // Safely update the specific member by email
        const updatedMembers = (groupData.members || []).map(member => {
            if (member.email === email) {
                return {
                    ...member,
                    github_username: githubUsername,
                };
            }
            return member;
        });

        await updateDoc(docRef, { members: updatedMembers });
        console.log(`Updated GitHub username for ${email} to ${githubUsername}`);
    } catch (error) {
        console.error("❌ Error updating GitHub username:", error);
        throw error;
    }
}

export async function updateDiscordUsername(groupId, email, discordUsername) {
    try {
        const docRef = doc(db, "Groups", groupId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
            throw new Error("Group not found");
        }

        const groupData = docSnap.data();

        const updatedMembers = (groupData.members || []).map(member => {
            if (member.email === email) {
                return {
                    ...member,
                    discord_username: discordUsername,
                };
            }
            return member;
        });

        await updateDoc(docRef, { members: updatedMembers });
        console.log(`Updated Discord username for ${email} to ${discordUsername}`);
    } catch (error) {
        console.error("❌ Error updating Discord username:", error);
        throw error;
    }
}

// Google Doc Integration Functions
// Update: Now primarily tracks word count instead of revision IDs
export async function updateGroupGoogleDocFile(groupId, fileId, wordCount) {
    try {
        if (!fileId || wordCount === null || wordCount === undefined) {
            console.warn("Missing fileId or wordCount for updateGroupGoogleDocFile");
            return false;
        }

        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        let updateData = {};

        // Always update word count and timestamp
        updateData[`googleDocs.${fileId}.lastWordCount`] = wordCount;
        updateData[`googleDocs.${fileId}.lastUpdated`] = new Date().toISOString();

        // Keep revision IDs for backward compatibility if they exist, but don't require them
        if (groupSnap.exists()) {
            const groupData = groupSnap.data();
            const existingFileData = groupData.googleDocs?.[fileId];

            // Preserve existing revision IDs if they exist (for backward compatibility)
            if (existingFileData?.revisionIds) {
                // Don't update revision IDs, just keep them
            }
        }

        await updateDoc(groupRef, updateData);
        console.log(`✅ Google Doc file ID ${fileId} word count ${wordCount} saved.`);
        return true
    } catch (error) {
        console.error("Error saving Google Doc file:", error);
        return false
    }
};

export async function getGroupGoogleDocFile(groupId, fileId) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        if (!groupSnap.exists()) {
            console.warn("Group not found:", groupId);
            return {
                success: false,
                message: `Group ${groupId} not found.`,
            };
        }

        const groupData = groupSnap.data();
        const fileEntry = groupData.googleDocs?.[fileId];

        if (!fileEntry) {
            console.warn("No file data found for fileId:", fileId);
            return {
                success: true,
                found: false,
            };
        }

        return {
            success: true,
            found: true,
            revisionIds: fileEntry.revisionIds || null,
            lastWordCount: fileEntry.lastWordCount || null,
            lastUpdated: fileEntry.lastUpdated || null,
        };
        // returns an object like { "1": "rev15", "2": "rev196" } or word count data
    } catch (error) {
        console.error("Error fetching revision IDs:", error);
        return {
            success: false,
            message: error.message || "Unknown error occurred.",
        };
    }
}

// Figma
export async function updateFigmaInfoForMember(groupId, email, figmaData) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        if (!groupSnap.exists()) {
            throw new Error("Group not found");
        }

        const groupData = groupSnap.data();
        const updatedMembers = (groupData.members || []).map((member) => {
            if (member.email === email) {
                return {
                    ...member,
                    figma: {
                        handle: figmaData.handle,
                        figma_id: figmaData.id,
                        access_token: figmaData.access_token,
                        refresh_token: figmaData.refresh_token,
                        expires_at: figmaData.expires_at,
                    },
                };
            }
            return member;
        });

        await updateDoc(groupRef, { members: updatedMembers });
        console.log(`Updated Figma data for ${email}`);
    } catch (error) {
        console.error("❌ Error updating Figma info:", error);
        throw error;
    }
}


export async function removeFigmaInfoForMember(groupId, email) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        if (!groupSnap.exists()) throw new Error("Group not found");

        const groupData = groupSnap.data();

        // Keep all members, just remove the figma field for the target one
        const updatedMembers = (groupData.members || []).map((member) => {
            if (member.email === email) {
                const { figma, ...rest } = member;
                return rest;
            }
            return member;  // return the original object, not `true`
        });

        await updateDoc(groupRef, { members: updatedMembers });
        console.log(`🗑️ Removed Figma data for ${email}`);
        return true;
    } catch (error) {
        console.error("❌ Error removing Figma info:", error);
        return false;
    }
}

export async function getFigmaTokenForMember(groupId, email) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);
        if (!groupSnap.exists()) {
            throw new Error("Group not found");
        }

        const members = groupSnap.data().members || [];
        const member = members.find((m) => m.email === email);
        if (!member?.figma) {
            console.warn("⚠️ No Figma data for this member");
            return {
                access_token: null,
                refresh_token: null,
                expires_at: 0,
            };
        }

        const { access_token, refresh_token, expires_at } = member.figma;
        return { access_token, refresh_token, expires_at };
    } catch (err) {
        console.error("❌ Error getting Figma token:", err);
        throw err;
    }
}

export async function updateFigmaTokensOnly(groupId, email, tokenData) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        if (!groupSnap.exists()) throw new Error("Group not found");

        const groupData = groupSnap.data();
        const members = groupData.members || [];

        const updatedMembers = members.map((member) => {
            if (member.email === email) {
                const existingFigma = member.figma || {};

                return {
                    ...member,
                    figma: {
                        ...existingFigma, // preserve handle and figma_id
                        access_token: tokenData.access_token ?? existingFigma.access_token,
                        refresh_token: tokenData.refresh_token ?? existingFigma.refresh_token,
                        expires_at: tokenData.expires_at ?? existingFigma.expires_at,
                    },
                };
            }
            return member;
        });

        await updateDoc(groupRef, { members: updatedMembers });
        console.log(`✅ Updated Figma tokens for ${email}`);
    } catch (error) {
        console.error("❌ Error updating Figma tokens:", error);
        throw error;
    }
}

export async function updateGroupFigmaFile(groupId, fileId, latestVersionId, pdfUrls, fileName, lastModified) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        let updateData = {};

        if (groupSnap.exists()) {
            const groupData = groupSnap.data();
            const existingFileData = groupData.figmaFiles?.[fileId];

            if (existingFileData && existingFileData.versionIds) {
                // Append new versionId with the next numeric index
                const versionIds = { ...existingFileData.versionIds };
                const nextIndex = (Object.keys(versionIds).length + 1).toString();
                versionIds[nextIndex] = latestVersionId;

                updateData[`figmaFiles.${fileId}.versionIds`] = versionIds;
            } else {
                // File exists but no versionIds yet, or not present
                updateData[`figmaFiles.${fileId}`] = {
                    versionIds: { "1": latestVersionId }
                };
            }
        } else {
            // Group doc doesn’t exist – create a new figmaFiles object
            updateData[`figmaFiles.${fileId}`] = {
                versionIds: { "1": latestVersionId }
            };
        }

        // Always persist the latest version ID and PDF URLs for cache lookups.
        updateData[`figmaFiles.${fileId}.latestVersionId`] = latestVersionId;
        if (pdfUrls?.length) {
            updateData[`figmaFiles.${fileId}.pdfUrls`] = pdfUrls;
        }
        if (fileName) {
            updateData[`figmaFiles.${fileId}.fileName`] = fileName;
        }
        if (lastModified) {
            updateData[`figmaFiles.${fileId}.lastModified`] = lastModified;
        }

        await updateDoc(groupRef, updateData);
        console.log(`✅ Figma file ID ${fileId} and version ID ${latestVersionId} saved.`);
        return true;
    } catch (error) {
        console.error("❌ Error saving Figma file:", error);
        return false;
    }
}

export async function getGroupFigmaFile(groupId, fileId) {
    try {
        const groupRef = doc(db, "Groups", groupId);
        const groupSnap = await getDoc(groupRef);

        if (!groupSnap.exists()) {
            console.warn("Group not found:", groupId);
            return { success: false, message: `Group ${groupId} not found.` };
        }

        const groupData = groupSnap.data();
        const fileEntry = groupData.figmaFiles?.[fileId];

        if (!fileEntry || !fileEntry.versionIds) {
            console.warn("No version data found for fileId:", fileId);
            return { success: true, found: false };
        }

        return {
            success: true,
            found: true,
            versionIds: fileEntry.versionIds,
            latestVersionId: fileEntry.latestVersionId || null,
            pdfUrls: fileEntry.pdfUrls || [],
            fileName: fileEntry.fileName || null,
            lastModified: fileEntry.lastModified || null,
        };
    } catch (error) {
        console.error("❌ Error fetching Figma version IDs:", error);
        return { success: false, message: error.message || "Unknown error occurred." };
    }
}

export async function setReviewDeadlineForAll(sessions, days) {
    // Same rule as new activities: days x 24 hours after the activity was submitted,
    // or after its artifact was last updated.
    try {
        const updatePromises = sessions.map(session => {
            const eventDocId = session?.eventId || session?.id;

            if (!eventDocId) {
                throw new Error('Missing event document id for session');
            }

            const docRef = doc(db, "Events", eventDocId);
            // created_at is overwritten on every edit, so prefer artifactLastModifiedAt when set.
            const startMs = toMillis(session.artifactLastModifiedAt) ?? toMillis(session.created_at);
            let deadline;
            if (startMs != null) {
                deadline = new Date(startMs + days * 24 * 60 * 60 * 1000);
            } else {
                // No submission timestamp on record: fall back to the end of activity date + days (local time).
                deadline = new Date(`${session.date}T00:00:00`);
                deadline.setDate(deadline.getDate() + days);
                deadline.setHours(23, 59, 59, 999);
            }

            return updateDoc(docRef, {
                reviewDeadline: deadline.toISOString(),
                reviewDeadlineDays: days,
                isPendingReview: true,
                isRatingLocked: false,
                updated_at: serverTimestamp()
            });
        });

        await Promise.all(updatePromises);

        console.log(`✅ Review deadline set for ${sessions.length} events (submission time + ${days} days)`);
        return { success: true, count: sessions.length, days };
    } catch (error) {
        console.error("❌ Error setting review deadlines:", error);
        throw error;
    }
}

export async function submitAssessment(eventId, raterEmail, memberRatings) {
    try {
        const colRef = collection(db, "Assessments");
        const existingQuery = query(
            colRef,
            where("eventId", "==", eventId),
            where("raterEmail", "==", raterEmail)
        );
        const existingSnapshot = await getDocs(existingQuery);

        if (!existingSnapshot.empty) {
            const existingDoc = existingSnapshot.docs[0];
            await updateDoc(existingDoc.ref, {
                memberRatings,
                updatedAt: serverTimestamp(),
            });

            console.log(`Assessment ${existingDoc.id} already existed for event ${eventId}; updated instead of creating a duplicate.`);
            return {
                success: true,
                assessmentId: existingDoc.id,
                eventId,
                raterEmail,
                memberRatings,
                updatedExisting: true,
            };
        }

        const newDocRef = doc(colRef);
        const assessmentId = newDocRef.id;

        const assessmentData = {
            assessmentId,
            eventId,
            raterEmail,
            memberRatings,
            createdAt: serverTimestamp(),
            submittedAt: serverTimestamp(),
        };

        await setDoc(newDocRef, assessmentData);

        console.log(`Assessment ${assessmentId} submitted for event ${eventId} by ${raterEmail}`);
        return { success: true, assessmentId, ...assessmentData };
    } catch (error) {
        console.error("Error submitting assessment:", error);
        throw error;
    }
}

export async function getAssessmentByUserAndEvent(eventId, raterEmail) {
    try {
        const assessmentsRef = collection(db, "Assessments");
        const q = query(
            assessmentsRef,
            where("eventId", "==", eventId),
            where("raterEmail", "==", raterEmail)
        );
        const querySnapshot = await getDocs(q);

        if (!querySnapshot.empty) {
            const docSnap = querySnapshot.docs[0];
            return { id: docSnap.id, ...docSnap.data() };
        }
        return null;
    } catch (error) {
        console.error("Error checking existing assessment:", error);
        throw error;
    }
}

export async function updateAssessment(assessmentId, memberRatings, options = {}) {
    try {
        const { modificationReason, context, trackHistory = true } = options;
        const assessmentRef = doc(db, "Assessments", assessmentId);
        const assessmentSnap = await getDoc(assessmentRef);

        if (!assessmentSnap.exists()) {
            throw new Error("Assessment not found");
        }

        const currentData = assessmentSnap.data();
        const previousRatings = currentData.memberRatings;

        if (trackHistory && modificationReason && context) {
            await saveRatingHistory(
                assessmentId,
                previousRatings,
                memberRatings,
                modificationReason,
                {
                    eventId: context.eventId || currentData.eventId,
                    raterEmail: context.raterEmail || currentData.raterEmail,
                    originalSubmittedAt: currentData.submittedAt,
                    courseId: context.courseId,
                    groupId: context.groupId,
                }
            );
        }

        await updateDoc(assessmentRef, {
            memberRatings,
            updatedAt: serverTimestamp(),
        });

        console.log(`Assessment ${assessmentId} updated successfully`);
        return { success: true, assessmentId };
    } catch (error) {
        console.error("Error updating assessment:", error);
        throw error;
    }
}

export async function saveRatingHistory(assessmentId, previousRatings, newRatings, modificationReason, context) {
    try {
        const historyRef = collection(db, "RatingHistory");
        const historyData = {
            assessmentId,
            eventId: context.eventId,
            raterEmail: context.raterEmail,
            raterName: context.raterName || null,
            previousRatings,
            newRatings,
            modificationReason,
            modifiedAt: serverTimestamp(),
            originalSubmittedAt: context.originalSubmittedAt,
            courseId: context.courseId || null,
            groupId: context.groupId || null,
            eventTitle: context.eventTitle || null,
            eventDate: context.eventDate || null,
        };

        const docRef = await addDoc(historyRef, historyData);
        console.log(`Rating history saved: ${docRef.id} for assessment ${assessmentId}`);
        return { success: true, historyId: docRef.id, ...historyData };
    } catch (error) {
        console.error("Error saving rating history:", error);
        throw error;
    }
}

export async function getAssessmentHistory(assessmentId) {
    try {
        const historyRef = collection(db, "RatingHistory");
        const q = query(
            historyRef,
            where("assessmentId", "==", assessmentId),
            orderBy("modifiedAt", "desc")
        );
        const querySnapshot = await getDocs(q);

        const history = [];
        querySnapshot.forEach((doc) => {
            history.push({ id: doc.id, ...doc.data() });
        });

        return history;
    } catch (error) {
        console.error("Error fetching assessment history:", error);
        throw error;
    }
}

export async function getEventRatingHistory(eventId) {
    try {
        const historyRef = collection(db, "RatingHistory");
        const q = query(
            historyRef,
            where("eventId", "==", eventId),
            orderBy("modifiedAt", "desc")
        );
        const querySnapshot = await getDocs(q);

        const history = [];
        querySnapshot.forEach((doc) => {
            history.push({ id: doc.id, ...doc.data() });
        });

        return history;
    } catch (error) {
        console.error("Error fetching event rating history:", error);
        throw error;
    }
}

export async function getModificationCountsByGroupId(groupId) {
    try {
        const historyRef = collection(db, "RatingHistory");
        const q = query(historyRef, where("groupId", "==", groupId));
        const snapshot = await getDocs(q);
        const counts = {};
        snapshot.forEach(doc => {
            const { eventId } = doc.data();
            if (eventId) counts[eventId] = (counts[eventId] || 0) + 1;
        });
        return counts;
    } catch (error) {
        console.error("Error fetching modification counts:", error);
        return {};
    }
}

export async function getAssessmentsByEvent(eventId) {
    try {
        const assessmentsRef = collection(db, "Assessments");
        const q = query(assessmentsRef, where("eventId", "==", eventId));
        const querySnapshot = await getDocs(q);

        const assessments = [];
        querySnapshot.forEach((docSnap) => {
            assessments.push({ id: docSnap.id, ...docSnap.data() });
        });

        return assessments;
    } catch (error) {
        console.error("Error fetching assessments:", error);
        throw error;
    }
}

export async function recalculateTotalSubmitted(eventId) {
    try {
        const assessmentsRef = collection(db, "Assessments");
        const q = query(assessmentsRef, where("eventId", "==", eventId));
        const snapshot = await getDocs(q);
        const actualCount = snapshot.size;

        const eventRef = doc(db, "Events", eventId);
        await updateDoc(eventRef, {
            totalSubmitted: actualCount
        });

        return actualCount;
    } catch (error) {
        console.error("Error recalculating totalSubmitted:", error);
        throw error;
    }
}

export async function syncAllEventsTotalSubmitted(eventIds) {
    try {
        const results = await Promise.all(
            eventIds.map(eventId => recalculateTotalSubmitted(eventId))
        );
        return results;
    } catch (error) {
        console.error("Error syncing all events:", error);
        throw error;
    }
}

export async function getGroupAssessmentData(groupId, groupMembers = []) {
    try {
        const eventIdsRef = collection(db, "Groups", groupId, "eventIds");
        const eventIdsSnapshot = await getDocs(eventIdsRef);
        const eventIds = eventIdsSnapshot.docs.map(doc => doc.id);

        const events = await Promise.all(eventIds.map(async (eventId) => {
            try {
                const eventRef = doc(db, "Events", eventId);
                const eventDoc = await getDoc(eventRef);
                if (eventDoc.exists()) {
                    return { id: eventDoc.id, ...eventDoc.data() };
                }
                return null;
            } catch (error) {
                console.error(`Error fetching event ${eventId}:`, error);
                return null;
            }
        }));
        const assessableEvents = events.filter(event => event !== null);

        if (assessableEvents.length === 0) {
            return {
                totalEvents: 0,
                assessedEvents: 0,
                assessments: [],
                memberProgress: [],
                averageScores: { volume: 0, quality: 0, importance: 0 },
                onTimeSubmissions: 0,
                totalSubmissions: 0,
                latestDeadline: null
            };
        }

        const chunkSize = 10;
        const allAssessmentsNested = [];

        for (let i = 0; i < assessableEvents.length; i += chunkSize) {
            const chunk = assessableEvents.slice(i, i + chunkSize);

            const results = await Promise.all(
                chunk.map(async (event) => {
                    const eventIdToQuery = event.eventId || event.id;
                    const eventAssessments = await getAssessmentsByEvent(eventIdToQuery);

                    return eventAssessments.map(a => ({
                        ...a,
                        eventData: event
                    }));
                })
            );

            allAssessmentsNested.push(...results);
        }

        const allAssessments = allAssessmentsNested.flat();

        const assessmentsByMember = new Map();
        for (const a of allAssessments) {
            if (!assessmentsByMember.has(a.raterEmail)) {
                assessmentsByMember.set(a.raterEmail, []);
            }
            assessmentsByMember.get(a.raterEmail).push(a);
        }
        const memberProgress = groupMembers.map(member => {
            const memberEmail = member.email;

            // Scores received: assessments on events where this member was a contributor
            let totImportance = 0, totQuality = 0, totVolume = 0, receivedCount = 0;
            const importanceDist = {1:0, 2:0, 3:0, 4:0};
            const qualityDist = {1:0, 2:0, 3:0, 4:0};
            const volumeDist = {1:0, 2:0, 3:0, 4:0};
            for (const a of allAssessments) {
                const contributorIds = a.eventData?.contributorIds || [];
                if (contributorIds.includes(memberEmail)) {
                    const ratings = a.memberRatings || {};
                    const importanceScore = ratings.importance?.score || 0;
                    const qualityScore = ratings.quality?.score || 0;
                    const volumeScore = ratings.volume?.score || 0;
                    totImportance += importanceScore;
                    totQuality += qualityScore;
                    totVolume += volumeScore;
                    if (importanceScore >= 1 && importanceScore <= 4) importanceDist[importanceScore]++;
                    if (qualityScore >= 1 && qualityScore <= 4) qualityDist[qualityScore]++;
                    if (volumeScore >= 1 && volumeScore <= 4) volumeDist[volumeScore]++;
                    receivedCount++;
                }
            }

            const eventsAsContributor = assessableEvents.filter(e =>
                (e.contributorIds || []).includes(memberEmail)
            ).length;
            const expectedReceivedCount = eventsAsContributor * groupMembers.length;

            const memberAssessments = assessmentsByMember.get(memberEmail) || [];
            let givenTotImportance = 0, givenTotQuality = 0, givenTotVolume = 0;
            const givenImportanceDist = {1:0, 2:0, 3:0, 4:0};
            const givenQualityDist = {1:0, 2:0, 3:0, 4:0};
            const givenVolumeDist = {1:0, 2:0, 3:0, 4:0};
            for (const a of memberAssessments) {
                const ratings = a.memberRatings || {};
                const i = ratings.importance?.score || 0;
                const q = ratings.quality?.score || 0;
                const v = ratings.volume?.score || 0;
                givenTotImportance += i;
                givenTotQuality += q;
                givenTotVolume += v;
                if (i >= 1 && i <= 4) givenImportanceDist[i]++;
                if (q >= 1 && q <= 4) givenQualityDist[q]++;
                if (v >= 1 && v <= 4) givenVolumeDist[v]++;
            }
            const givenCount = memberAssessments.length;
            return {
                email: memberEmail,
                name: member.name || memberEmail,
                initial: member.initial || (member.name || memberEmail).charAt(0).toUpperCase(),
                color: member.color || '#9ca3af',
                completed: givenCount,
                total: assessableEvents.length,
                receivedCount,
                expectedReceivedCount,
                scores: {
                    importance: { total: totImportance, avg: receivedCount > 0 ? (totImportance / receivedCount).toFixed(2) : '0.00', distribution: importanceDist },
                    quality: { total: totQuality, avg: receivedCount > 0 ? (totQuality / receivedCount).toFixed(2) : '0.00', distribution: qualityDist },
                    volume: { total: totVolume, avg: receivedCount > 0 ? (totVolume / receivedCount).toFixed(2) : '0.00', distribution: volumeDist },
                },
                givenScores: {
                    importance: { total: givenTotImportance, avg: givenCount > 0 ? (givenTotImportance / givenCount).toFixed(1) : '0.0', distribution: givenImportanceDist },
                    quality: { total: givenTotQuality, avg: givenCount > 0 ? (givenTotQuality / givenCount).toFixed(1) : '0.0', distribution: givenQualityDist },
                    volume: { total: givenTotVolume, avg: givenCount > 0 ? (givenTotVolume / givenCount).toFixed(1) : '0.0', distribution: givenVolumeDist },
                },
            };
        });

        let totalVolume = 0, totalQuality = 0, totalImportance = 0;
        let scoreCount = 0;
        let onTimeCount = 0;

        for (const assessment of allAssessments) {
            const ratings = assessment.memberRatings ?? {};

            if (ratings.volume?.score) {
                totalVolume += ratings.volume.score;
                scoreCount++;
            }
            if (ratings.quality?.score) totalQuality += ratings.quality.score;
            if (ratings.importance?.score) totalImportance += ratings.importance.score;

            const eventDeadline = assessment.eventData?.reviewDeadline;
            const submittedAt = assessment.submittedAt?.toDate?.() || assessment.createdAt?.toDate?.();

            if (!eventDeadline || !submittedAt || submittedAt <= new Date(eventDeadline)) {
                onTimeCount++;
            }
        }


        const averageScores = scoreCount > 0 ? {
            volume: (totalVolume / scoreCount).toFixed(1),
            quality: (totalQuality / scoreCount).toFixed(1),
            importance: (totalImportance / scoreCount).toFixed(1)
        } : { volume: 0, quality: 0, importance: 0 };


        // Find the latest deadline
        const deadlines = assessableEvents
            .filter(e => e.reviewDeadline)
            .map(e => new Date(e.reviewDeadline));
        const latestDeadline = deadlines.length > 0
            ? new Date(Math.max(...deadlines))
            : null;

        const totalExpectedAssessments = groupMembers.length * assessableEvents.length;

        const assessedEventIds = new Set(
            allAssessments.map(a => a.eventId)
        );

        const assessedEventsCount = assessableEvents.filter(e =>
            assessedEventIds.has(e.id)
        ).length;

        return {
            totalEvents: assessableEvents.length,
            assessedEvents: assessedEventsCount,
            assessments: allAssessments,
            memberProgress,
            averageScores,
            onTimeSubmissions: onTimeCount,
            totalSubmissions: allAssessments.length,
            totalExpectedAssessments,
            latestDeadline
        };
    } catch (error) {
        console.error("Error getting group assessment data:", error);
        throw error;
    }
}

export async function getCourseAssessmentAverages(courseId) {
    try {
        const groupsSnapshot = await getDocs(
            query(collection(db, "Groups"), where("courseId", "==", courseId))
        );

        let totalVolume = 0, totalQuality = 0, totalImportance = 0;
        let scoreCount = 0;

        // fetch all eventIds in parallel
        const allEventIds = [];

        await Promise.all(
            groupsSnapshot.docs.map(async (groupDoc) => {
                const eventIdsSnapshot = await getDocs(
                    collection(db, "Groups", groupDoc.id, "eventIds")
                );

                eventIdsSnapshot.docs.forEach(doc => {
                    allEventIds.push(doc.id);
                });
            })
        );

        //fetch all assessments in parallel
        const allAssessments = await Promise.all(
            allEventIds.map(eventId => getAssessmentsByEvent(eventId))
        );

        // process data (sync, fast)
        for (const assessments of allAssessments) {
            for (const assessment of assessments) {
                const ratings = assessment.memberRatings ?? {};

                if (ratings.volume?.score) {
                    totalVolume += ratings.volume.score;
                    scoreCount++;
                }
                if (ratings.quality?.score) totalQuality += ratings.quality.score;
                if (ratings.importance?.score) totalImportance += ratings.importance.score;
            }
        }

        if (scoreCount === 0) {
            return { volume: 0, quality: 0, importance: 0 };
        }

        return {
            volume: (totalVolume / scoreCount).toFixed(1),
            quality: (totalQuality / scoreCount).toFixed(1),
            importance: (totalImportance / scoreCount).toFixed(1)
        };
    } catch (error) {
        console.error("Error getting course assessment averages:", error);
        return { volume: 0, quality: 0, importance: 0 };
    }
}

// Draft (Discord claim) helpers
const DRAFTS_COLLECTION = "Drafts";

export async function getDraft(draftId) {
    const useEmulator = process.env.REACT_APP_USE_EMULATOR === "true";
    console.log("[getDraft] request", {
        draftId,
        collection: DRAFTS_COLLECTION,
        useEmulator,
    });
    try {
        const docRef = doc(db, DRAFTS_COLLECTION, draftId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            console.log("[getDraft] found", { draftId, docId: docSnap.id });
            return { id: docSnap.id, ...docSnap.data() };
        }
        console.log("[getDraft] not found (no document)", { draftId, useEmulator });
        return null;
    } catch (error) {
        console.error("[getDraft] error", { draftId, useEmulator, error });
        throw error;
    }
}

export async function claimDraft(draftId, userId) {
    try {
        const docRef = doc(db, DRAFTS_COLLECTION, draftId);
        await updateDoc(docRef, {
            claimed: true,
            claimedBy: userId,
            claimedAt: serverTimestamp(),
        });
        return true;
    } catch (error) {
        console.error("Error claiming draft:", error);
        throw error;
    }
}

/** Deletes a draft document from the Drafts collection (e.g. after activity is saved). */
export async function deleteDraft(draftId) {
    try {
        const docRef = doc(db, DRAFTS_COLLECTION, draftId);
        await deleteDoc(docRef);
        return true;
    } catch (error) {
        console.error("Error deleting draft:", error);
        throw error;
    }
}

export async function submitIssueReport({ description, pageUrl, userEmail, userId, attachments, errorLog }) {
    const reportRef = doc(collection(db, 'IssueReports'));
    const reportId = reportRef.id;

    const uploadedAttachments = [];
    for (let i = 0; i < attachments.length; i++) {
        const file = attachments[i];
        const ext = file.type.split('/')[1]?.split(';')[0] || 'bin';
        const storageRef = ref(storage, `issue_reports/${reportId}/attachment_${i}.${ext}`);
        await uploadBytes(storageRef, file);
        uploadedAttachments.push({ url: await getDownloadURL(storageRef), type: file.type });
    }

    await setDoc(reportRef, {
        description,
        pageUrl,
        userEmail,
        userId: userId || null,
        attachments: uploadedAttachments,
        errorLog: errorLog || [],
        status: 'new',
        timestamp: serverTimestamp(),
    });
}

export { auth, provider, db, functions, httpsCallable };
